import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'
import Dashboard from '@/views/Dashboard.vue'
import HistoryActivity from '@/views/HistoryActivity.vue'
import Users from '@/views/Users.vue'
import Reports from '@/views/Reports.vue'
import Settings from '@/views/Settings.vue'
import SubSetting1 from '@/views/SubSetting1.vue'
import SubSetting2 from '@/views/SubSetting2.vue'
import SubSetting3 from '@/views/SubSetting3.vue'
import Login from '@/views/Login.vue'

import VueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

// ---------- CONFIG ----------
const localStorageWrapper =
  typeof window !== 'undefined'
    ? {
      get token() {
        return window.localStorage?.getItem('isToken') || ''
      },
    }
    : { token: '' }

// ---------- AXIOS INTERCEPTOR ['https://instructor.dev.muic.io/api/', 'https://api4.allaremore-arm.dev/'] ----------
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api4.allaremore-arm.dev/'
// axios.defaults.baseURL = 'https://instructor.muic.io/api/'

axios.interceptors.request.use(async config => {
  if (!config.headers) config.headers = {}

  const authType = localStorage.getItem('isAuthenType')

  if (authType === 'MSAL') {
    // MSAL: ดึง accessToken จาก msal instance
    try {
      const msal = Vue.prototype.$msal
      if (msal) {
        const accounts = msal.getAllAccounts()
        if (accounts.length > 0) {
          const tokenResponse = await msal.acquireTokenSilent({
            account: accounts[0],
            scopes: ['api://cd589853-e246-4124-a2cc-3b3bb299db78/instructor-prod'],
          })
          if (tokenResponse?.accessToken) {
            config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`
          }
        }
      }
    } catch (err) {
      console.error('[MSAL] Token acquisition failed:', err)
      // Fallback to stored token
      const storedToken = localStorageWrapper.token
      if (storedToken) {
        config.headers.Authorization = `Bearer ${storedToken}`
      }
    }
  } else {
    // Keycloak หรืออื่นๆ: ใช้ token จาก localStorage
    const token = localStorageWrapper.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  return config
})

// ---------- WHOAMI FUNCTION ----------
const whoami = async () => {
  try {
    const res = await axios.get('/whoami/')
    if (res.status === 200 && res.data) {

      const userData = res.data
      // console.log('✅ whoami success:', res.data)

      // ->
      localStorage.setItem('username', userData.username || userData.name || '')
      localStorage.setItem('permissions', JSON.stringify(userData.permissions || []))

      return res.data
    }
    return false
  } catch (error) {
    // console.warn('❌ whoami failed:', error?.response?.status)
    return false
  }
}

// ---------- ROUTES ----------
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'Dashboard', component: Dashboard },
      { path: 'users', name: 'Users', component: Users },
      { path: 'activitylist', name: 'HistoryActivity', component: HistoryActivity },
      { path: 'reports', name: 'Reports', component: Reports },
      { path: 'settings', name: 'Settings', component: Settings },
      { path: 'settings/sub_setting_1', name: 'SubSetting1', component: SubSetting1 },
      { path: 'settings/sub_setting_2', name: 'SubSetting2', component: SubSetting2 },
      { path: 'settings/sub_setting_3', name: 'SubSetting3', component: SubSetting3 },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// ---------- ROUTER GUARD ----------
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
  const isAuthenType = localStorage.getItem('isAuthenType')

  // ถ้า route ต้องการ auth → ตรวจสอบ token + whoami
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }

    // ตรวจสอบ whoami ทั้ง Keycloak และ MSAL
    const user = await whoami()
    if (!user) {
      const failedAuthType = isAuthenType // เก็บไว้ก่อน clear
      localStorage.clear()
      sessionStorage.clear()

      // เก็บ flag ว่า whoami ล้มเหลว
      localStorage.setItem('whoamiFailed', failedAuthType || 'unknown')

      return next({ name: 'Login' })
    }

    next()
  }

  // ถ้าอยู่หน้า login แต่ล็อกอินแล้ว → กลับไป Dashboard
  else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
export { whoami }
